var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5H2C1.7 5.5 1.5 5.7 1.5 6C1.5 6.25 1.7 6.45 1.9 6.5C1.65 6.95 1.5 7.45 1.5 8C1.5 8.3 1.7 8.5 2 8.5C2.3 8.5 2.5 8.3 2.5 8C2.5 7.5 2.7 7 3.05 6.65L3.35 6.35C3.5 6.2 3.55 6 3.45 5.8C3.4 5.6 3.2 5.5 3 5.5Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5H6C5.7 5.5 5.5 5.7 5.5 6C5.5 6.25 5.7 6.45 5.9 6.5C5.65 6.95 5.5 7.45 5.5 8C5.5 8.3 5.7 8.5 6 8.5C6.3 8.5 6.5 8.3 6.5 8C6.5 7.5 6.7 7 7.05 6.65L7.35 6.35C7.5 6.2 7.55 6 7.45 5.8C7.4 5.6 7.2 5.5 7 5.5Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10.3 8.5 10.5 8.3 10.5 8C10.5 7.5 10.7 7 11.05 6.65L11.35 6.35C11.5 6.2 11.55 6 11.45 5.8C11.4 5.6 11.2 5.5 11 5.5H10C9.7 5.5 9.5 5.7 9.5 6C9.5 6.25 9.7 6.45 9.9 6.5C9.65 6.95 9.5 7.45 9.5 8C9.5 8.3 9.7 8.5 10 8.5Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0C13.65 0 13 0.65 13 1.5C13 2.15 13.4 2.7 14 2.9V8H13V4.5V3.5C13 1.55 11.45 0 9.5 0H3.5C1.55 0 0 1.55 0 3.5V4.5V9.5V13.5C0 13.8 0.2 14 0.5 14H12.5C12.8 14 13 13.8 13 13.5V9.5V9H14.5C14.8 9 15 8.8 15 8.5V2.9C15.6 2.7 16 2.15 16 1.5C16 0.65 15.35 0 14.5 0ZM5 5H8V9H5V5ZM1 5H4V9H1V5ZM8.5 12H4.5C4.2 12 4 11.8 4 11.5C4 11.2 4.2 11 4.5 11H8.5C8.8 11 9 11.2 9 11.5C9 11.8 8.8 12 8.5 12ZM12 9H9V5H12V9Z",
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3039_2337",
    x1: 1.94307,
    y1: 5.5,
    x2: 3.67666,
    y2: 7.39143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A64FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3039_2337",
    x1: 5.94307,
    y1: 5.5,
    x2: 7.67666,
    y2: 7.39143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A64FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3039_2337",
    x1: 9.94307,
    y1: 5.5,
    x2: 11.6767,
    y2: 7.39143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A64FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3039_2337",
    x1: 3.54098,
    y1: -6.30586e-8,
    x2: 10.298,
    y2: 12.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A64FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.e1d057335c620706e3bb68d978a27e80.svg";
export { ForwardRef as ReactComponent };